import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../moderator/Sidebar';
import { Navbar } from '../Navbar';

export const MainLayout = () => {
  return (
    <div className="min-h-screen bg-indigo-100 flex flex-col">
      {/* HEADER / NAVBAR: 
          - lg:ml-72: Desktop par sidebar ki jagah chorega.
          - z-40: Sidebar (z-60) se neechay rakha hai taake mobile par sidebar iske upar aaye.
      */}
      <header className="h-16 bg-indigo-800 border-b border-slate-100 sticky top-0 z-40 w-full transition-all duration-300 lg:pl-72">
        <Navbar />
      </header>

      <div className="flex flex-1 relative">
        {/* SIDEBAR:
            Internal logic (z-60) mobile par overlay banay gi aur desktop par fixed rahegi.
        */}
        <Sidebar />

        {/* MAIN CONTENT AREA:
            - lg:ml-72: Sidebar ki width (288px) ke barabar margin.
            - w-full: Mobile par poori screen cover karega.
        */}
        <main className="flex-1 w-full transition-all duration-300 lg:ml-72 flex flex-col">
          <div className="p-3 md:p-6 lg:p-8 flex-1">
            {/* PAGE CONTENT CARD:
                SaaS style rounded corners aur shadow.
            */}
            <div className="bg-indigo-50/50 rounded-2xl shadow-sm border border-slate-200/60 min-h-[calc(100vh-140px)] p-4 md:p-8">
              <Outlet />
            </div>
          </div>

          {/* Footer Space for Mobile Bottom Nav (if any) */}
          <footer className="h-6 lg:hidden"></footer>
        </main>
      </div>
    </div>
  );
};